module.exports = __webpack_public_path__ + "img/phone_head.c91f1ff2.png";